import { ChatEventExtensions } from '@spotify/plugin-confidence-chat-react';

import { AssistantMessageEventExtension } from './AssistantMessageEventExtension';
import {
  ChatErrorEventExtension,
  NotificationEventExtension,
  ThinkingEventExtension,
  ToolConfirmationRequestEventExtension,
  ToolConfirmationResponseEventExtension,
  UserInterruptEventExtension,
} from './ChatEventExtensions';
import { UserMessageEventExtension } from './UserMessageEventExtension';

export const DefaultChatEventExtensions = () => (
  <ChatEventExtensions>
    <UserMessageEventExtension />
    <AssistantMessageEventExtension />
    <ThinkingEventExtension />
    <ToolConfirmationRequestEventExtension />
    <ToolConfirmationResponseEventExtension />
    <NotificationEventExtension />
    <UserInterruptEventExtension />
    <ChatErrorEventExtension />
  </ChatEventExtensions>
);
